import React from 'react'
import Icon from "../../../assets/images/brush.png"
import AboutImg from "../../../assets/images/about.png"
import AboutIcon from "../../../assets/images/about-icon.png"
import { Link } from 'react-router-dom'
import { config } from '../config'

const About = ({data}) => {
    return (
        <div>
            <div id="rs-about" className="rs-about style4 pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row y-middle d-flex align-items-center">
                        <div className="col-lg-6 md-mb-50">
                            <div className="about-images pt-xl-3">
                                <img src={data[1]?.imageUrl} alt="" style={{objectPosition:"top"}} className='w-100 h-100 object-fit-contain' />
                                <div className="about-widget wow fadeInUp" >
                                    <div className="services-item">
                                        <div className="services-icon">
                                            <img src={AboutIcon} alt="" />
                                        </div>
                                        <div className="services-content">
                                            <h2 className="services-desc">
                                                Leading Cleaning
                                                Agency Since 2001
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 pr-55 md-pr-15">
                            <div className="sec-title2 content">
                                <div className="brush-content mb-20">
                                    <img src={Icon} alt="" />
                                        <span className="sub-text">{data[1]?.subtitle}</span>
                                </div>
                                <h2 className="title pb-20">
                                    {data[1]?.title}
                                </h2>
                                <div className="desc about pb-25" dangerouslySetInnerHTML={{__html : data[1]?.description}}>
                                    
                                </div> 
                                <div className="btn-part mt-5">
                                    
                                    <Link to={`${config.appUrl}contact-us`} className="readon about" >
                                        <span className="btn-text">Inquiry Now</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
